module.exports = __webpack_public_path__ + "assets/f59696ab0f6f26c339d7e6bb1d73a5c3.js";